import { type ShortUrlResponse } from '@air/api/types';
import { PERCENT_SCALE } from '@air/utilities';

export type CoverImageRegion = NonNullable<
  NonNullable<ShortUrlResponse['presentationSettings']>['coverImage']
>['region'];

export type CoverImageFocalPoint = {
  x: number;
  y: number;
};

const CENTERED_FOCAL_POINT = 0.5;

// The saved region describes the visible crop window in percent units. Convert that window into a
// 0–1 pan: a window occupying `height`% of the image leaves `100 - height`% of travel, making
// `top / (100 - height)` the fraction of that travel. A full-extent axis has no travel to
// distribute, so it centers at 0.5. This is the author's Reposition movement (CSS object-position
// uses the 0–100% form; Imgix `crop=focalpoint` takes the same 0–1 value as fp-x/fp-y). Mirrors
// the board-cover mapping in BoardCover.tsx.
export const getCoverImageFocalPoint = (region: CoverImageRegion): CoverImageFocalPoint => {
  const { top, left = 0, width = PERCENT_SCALE, height = PERCENT_SCALE } = region;

  const y = height >= PERCENT_SCALE ? CENTERED_FOCAL_POINT : top / (PERCENT_SCALE - height);
  const x = width >= PERCENT_SCALE ? CENTERED_FOCAL_POINT : left / (PERCENT_SCALE - width);

  return { x, y };
};
